export default "__VITE_ASSET__xvMDpY8N__"